export default __webpack_public_path__ + "static/media/kitchen3-afterD-480w.7c3f43f9.avif";